import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import type { ComingUpFeatureItem } from '../types'
import { ComingUpFeaturesCard } from './ComingUpFeaturesCard'
import SectionHeading from './SectionHeading'

interface ComingUpCarouselProps {
  items: ComingUpFeatureItem[]
}

const ComingUpCarousel = ({ items }: ComingUpCarouselProps) => {
  return (
    <div className="flex flex-col gap-4">
      <SectionHeading>Coming up</SectionHeading>
      <Carousel opts={{ align: 'start', loop: false }} className="w-full">
        <CarouselContent className="-ml-4">
          {items.map((item, i) => (
            <CarouselItem key={i} className="pl-4 sm:basis-1/2 lg:basis-1/4">
              <ComingUpFeaturesCard item={item} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="-left-4 lg:-left-10 rounded-md" />
        <CarouselNext className="-right-4 lg:-right-10 rounded-md" />
      </Carousel>
    </div>
  )
}

export default ComingUpCarousel
